module.exports = __webpack_public_path__ + "static/fullmaktsformular-2024-b5f34a208cb7c87bb59fa54094c4825d.pdf";